<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import MsoAddEditForm from "@/components/models/practice/forms/MsoAddEditForm.vue";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.mso" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PRACTICE__MSO);
    },
  },
});
</script>

<template>
  <v-skeleton-loader>
    <mso-add-edit-form />
  </v-skeleton-loader>
</template>
